import React, { FC, ReactNode } from 'react';
import './style.scss';
import useDeviceInfo from '../../../services/hooks/useDevice';
interface Iprops {
  children: ReactNode;
}
const ThemeLayout: FC<Iprops> = ({ children }: Iprops) => {
  const { device } = useDeviceInfo();
  if (device.type === "mobile") {
    return (
      <div className={`bg-white`}>
        {children}
      </div>
    )
  }
  return (
    <div className={`pagecontainer`}>
      {children}
    </div>
  );
};
export default ThemeLayout;
